import React from 'react';
import { formatTime } from '../../../utils/statsUtils';
import './AlgorithmStats.css';

const AlgorithmStats = ({ alg, isExpanded }) => {
  return (
    <div className="alg-item">
      <div className="alg-header">
        <span className="alg-name">{alg.name}</span>
      </div>
      
      {isExpanded && (
        <div className="alg-stats">
          <div className="stat-row">
            <span className="stat-label">Attempts:</span>
            <span className="stat-value">{alg.totalAttempts}</span>
          </div>
          <div className="stat-row">
            <span className="stat-label">Last Time:</span>
            <span className="stat-value">{formatTime(alg.lastTime)}</span>
          </div>
          {alg.fastestTime && (
            <div className="stat-row">
              <span className="stat-label">Best:</span>
              <span className="stat-value">{formatTime(alg.fastestTime)}</span>
            </div>
          )}
          {alg.rollingAverage5 && (
            <div className="stat-row">
              <span className="stat-label">Ao5:</span>
              <span className="stat-value">{formatTime(alg.rollingAverage5)}</span>
            </div>
          )}
          {alg.rollingAverage12 && (
            <div className="stat-row">
              <span className="stat-label">Ao12:</span>
              <span className="stat-value">{formatTime(alg.rollingAverage12)}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AlgorithmStats; 